import { Injectable } from '@angular/core';
import { AngularFireDatabase } from '@angular/fire/database';

@Injectable({
  providedIn: 'root'
})
export class ConversationService {
  editConversation(message: any) {
    return this.angularFirebaseDatabase.object('conversations/'+message.uid+'/'+message.timestamp).set(message);
  }

  constructor(
    private angularFirebaseDatabase: AngularFireDatabase
  ) { }
  createConversation(conversation){
    return this.angularFirebaseDatabase.object('conversations/'+conversation.uid+'/'+conversation.timestamp).set(conversation);
  }
  getConversation(uid){
    return this.angularFirebaseDatabase.list('conversations/'+uid);
  }
}
